import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { news } from '../../data/news';
export function NewsSection() {
  const [lead, ...rest] = news;
  return <section id="actualites" className="bg-cloud py-20 lg:py-24" data-id="element-157" data-mp="cwa6wg6gbocz">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-158" data-mp="3u81qd99atnoy">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-159" data-mp="30791mimubvu">
          <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-160" data-mp="32a5opeaj39j">Actualités fédérales</h2>
          <a href="#actualites" className="ffp-focus inline-flex items-center gap-2 text-[14px] font-semibold text-navy" data-id="element-161" data-mp="vp4nfejq3ojb">
            Toutes les actualités
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-162" data-mp="gzozs7fhnz7u" />
          </a>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.15fr_0.85fr] lg:gap-12" data-id="element-163" data-mp="ly07ocm83znf">
          <article className="flex flex-col" data-id="element-164" data-mp="19nuloxia3u99">
            <p className="text-[12px] font-bold uppercase tracking-wider text-flag" data-id="element-165" data-mp="19mt0i07jtrdt">{lead.category}</p>
            <h3 className="ffp-display mt-3 text-2xl font-extrabold leading-tight text-ink lg:text-[34px]" data-id="element-166" data-mp="1ehgpe06gsnsx">
              {lead.title}
            </h3>
            <p className="mt-4 text-[16px] leading-relaxed text-ink/70" data-id="element-167" data-mp="tcq8ayuxfgee">{lead.excerpt}</p>
            <a href="#securite" className="ffp-focus mt-auto inline-flex items-center gap-2 pt-6 text-[14px] font-semibold text-navy" data-id="element-168" data-mp="180tea88yys37">
              Lire la suite
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-169" data-mp="1h085xb0vh8pa" />
            </a>
            <p className="mt-4 text-[13px] text-ink/45" data-id="element-170" data-mp="1c2y7j5vi9mpb">{lead.date}</p>
          </article>

          <div className="border-t border-line" data-id="element-171" data-mp="1qzz1zh52zvrh">
            {rest.map(item => <article key={item.id} className="border-b border-line py-5" data-id="element-172" data-mp="1m0cl8xq1nxdx">
                <p className="text-[12px] font-bold uppercase tracking-wider text-azure" data-id="element-173" data-mp="1ly9lvn304rwj">{item.category}</p>
                <h3 className="ffp-display mt-2 text-[18px] font-bold leading-snug text-ink" data-id="element-174" data-mp="3ssn5lrln0l7s">{item.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-ink/65" data-id="element-175" data-mp="hagw2tpybwjp">{item.excerpt}</p>
                <p className="mt-3 text-[12px] text-ink/45" data-id="element-176" data-mp="lc2esvp6351t">{item.date}</p>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}